import React from 'react'
import { Icon } from '@ztechapps/webui.util'
import { LogoutButton } from '@ztechapps/webui.button'
import { AccountJoinContainer } from './AccountJoinContainer'

export const AccountJoinInActive = ({ user }) => {
  return (
    <AccountJoinContainer
      title="Your account was set as in-active"
      description={
        <p>
          Your administrator sets your account as <span className="fw-bold text-danger">In-Active</span>. Contact your administrator if think this is
          a mistake, else you cannot use the application.
        </p>
      }
    >
      <h1 className="text-center">
        <Icon name="ban" className="fa-5x text-warning" />
      </h1>
      <div className="row m-1 text-center">
        <LogoutButton text={`Sign out ${user?.profile?.email}`} />
      </div>
    </AccountJoinContainer>
  )
}
